import { CustomGetProjectsResult, CustomSetProjectResult } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class Project<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * No description
	 *
	 * @tags project
	 * @name ProjectGetProjects
	 * @summary Gets projects for a customer.
	 * @request GET:/store/{storeId}/fca/project/getProjects
	 * @secure
	 * @response `200` `CustomGetProjectsResult` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	projectGetProjects = (
		storeId: string,
		query?: {
			/**
			 * 1=projectId desc, 2=alpha
			 * @example 1, 2
			 */
			sortOrder?: number;
			/**
			 * search keyword
			 * @example tm
			 */
			keyword?: string;
			/**
			 * page size
			 * @example 5
			 */
			pageSize?: number;
			/**
			 * requested page
			 * @example 1, 2
			 */
			pageNumber?: number;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('projectGetProjects'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: null ?? {},
				methodName: 'projectGetProjects',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<CustomGetProjectsResult, void>({
			path: `/store/${storeId}/fca/project/getProjects`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
	/**
	 * No description
	 *
	 * @tags project
	 * @name ProjectSetProject
	 * @summary Sets active project for the order.
	 * @request GET:/store/{storeId}/fca/project/setProject/{projectId}
	 * @secure
	 * @response `200` `CustomSetProjectResult` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	projectSetProject = (storeId: string, projectId?: string, params: RequestParams = {}) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('projectSetProject'))
		) {
			const paramsLogger = logger.child({
				params,
				query: null ?? {},
				body: null ?? {},
				methodName: 'projectSetProject',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<CustomSetProjectResult, void>({
			path: `/store/${storeId}/fca/project/setProject/${projectId}`,
			method: 'GET',
			secure: true,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
